import React, {useEffect, useRef, useState} from 'react';

import {useTranslation} from 'react-i18next';

import CORE_Applet from '@medad-sep/applet-core';
import {ApiConnector, App, AppletDefinition} from '@medad-sep/core';
import {PagesItems} from '@medad-sep/shell-default/components/PagesList';
import {getServicePage} from '@medad-sep/shell-default/components/ServicePage';

import playgroundConfig from '../../../applet-playground';
import {Main} from '../components/Main';
import {AppletPreviewValues} from '../models';

import {withPreviewView} from './withPreviewView';

export function usePreviewValues(): {isAppletReady: boolean; previewValues: AppletPreviewValues} {
  const [isAppletReady, setIsAppletReady] = useState(false);
  const {t, i18n} = useTranslation();

  const values = useRef<{
    app?: App;
    appletsList?: AppletDefinition[];
    connectors?: ApiConnector[];
    screens?: any[];
    Main?: any;
  }>({});

  useEffect(() => {
    const applet: AppletDefinition = playgroundConfig.applet as any;
    const connector: ApiConnector = playgroundConfig.connector as any;

    values.current = {
      appletsList: [applet, CORE_Applet],
      connectors: [
        {...connector, id: applet.id, enabled: true},
        {id: CORE_Applet.id, enabled: true, credentials: {}, settings: {}},
      ],
      app: {
        id: 'playground',
        brandColor: '#4A90E2',
        structure: {pages: [], launcher: {}, auxiliaryPages: []},
        designSystem: 'medad',
      },
      screens: [],
    };

    const pageItems: PagesItems = [];

    Promise.all([applet.load(), CORE_Applet.load()]).then(([cmpModule, coreModule]) => {
      const loadedCmp = cmpModule.default;
      const loadedCore = coreModule.default;

      loadedCmp.widgets.forEach((it) => {
        it.Component = withPreviewView(it.Component);
      });

      [...loadedCmp.services, ...loadedCmp.widgets].forEach((it) => {
        values.current.screens?.push(getServicePage(it, t, i18n));
        pageItems.push({id: it.id, icon: it.Icon || 'HexagonIcon', title: it.name, type: 'Launcher'});
      });

      loadedCore.services.forEach((service) => {
        values.current.screens?.push(getServicePage(service, t, i18n));
      });

      values.current.Main = () => <Main pageItems={pageItems} />;

      setIsAppletReady(true);
    });
  }, []);

  return {isAppletReady, previewValues: values.current};
}
